declare global {
  interface Window {
    __ENV__?: Record<string, string>;
  }
}

const runtimeEnv = (typeof window !== 'undefined' && window.__ENV__) ? window.__ENV__ : {};
const buildEnv = process.env as Record<string, string | undefined>;

const getEnvValue = (key: string): string | undefined => {
  const runtimeValue = runtimeEnv[key];
  if (runtimeValue !== undefined && runtimeValue !== '') {
    return runtimeValue;
  }
  const buildValue = buildEnv[key];
  if (buildValue !== undefined && buildValue !== '') {
    return buildValue;
  }
  return undefined;
};

export const ENV = {
  API_URL: getEnvValue('REACT_APP_API_URL') || getEnvValue('NEXT_PUBLIC_API_URL') || '',
  LOCAL_API_URL: getEnvValue('REACT_APP_LOCAL_API_URL') || getEnvValue('NEXT_PUBLIC_LOCAL_API_URL') || '',
  RUNTIME_TARGET: getEnvValue('REACT_APP_RUNTIME_TARGET') || getEnvValue('NEXT_PUBLIC_RUNTIME_TARGET') || '',
  API_URL_USERNAME: getEnvValue('REACT_APP_API_URL_USERNAME') || getEnvValue('NEXT_PUBLIC_API_URL_USERNAME') || '',
  API_URL_PASSWORD: getEnvValue('REACT_APP_API_URL_PASSWORD') || getEnvValue('NEXT_PUBLIC_API_URL_PASSWORD') || '',
  CLERK_DOMAIN: getEnvValue('REACT_APP_CLERK_DOMAIN') || getEnvValue('NEXT_PUBLIC_CLERK_DOMAIN') || '',
  CLERK_PUBLISHABLE_KEY: getEnvValue('REACT_APP_CLERK_PUBLISHABLE_KEY') || getEnvValue('NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY') || '',
  STRIPE_PUBLISHABLE_KEY: getEnvValue('REACT_APP_STRIPE_PUBLISHABLE_KEY') || '',
  EMAILJS_SERVICE_ID: getEnvValue('REACT_APP_EMAILJS_SERVICE_ID') || '',
  EMAILJS_TEMPLATE_ID: getEnvValue('REACT_APP_EMAILJS_TEMPLATE_ID') || '',
  EMAILJS_PUBLIC_KEY: getEnvValue('REACT_APP_EMAILJS_PUBLIC_KEY') || '',
};
